import React from "react";
import MaterialDropdown from "../../dropdown/materialDropdown";
import { useSelector } from "react-redux";
import { IReduxStateData } from "../../../interfaces/redux";
import { BASEBALL_STATISTICS_MENU } from "../../../constant/match";

export default function ProfileStatisticsHeader(props: any) {
  const globalState = useSelector((state: IReduxStateData) => state);
  const selectedLang = globalState?.selectedLang || "";
  return (
    <div className="d-flex align-items-center justify-content-between stats-bar">
      <h3 className="bold theme-green mb-0">{BASEBALL_STATISTICS_MENU[selectedLang]['title']}</h3>
      <MaterialDropdown {...props} />
    </div>
  );
}
